import React from 'react'

import { StyleSheet, Keyboard, Platform, ScrollView, View, Image } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import client from '@sart/client'
import { useContent } from '@sart/content'
import { prettyErrorMessage, testID } from '@sart/utilities'
import { adaptive, backgroundColors, typography, colors } from '@sart/styles'
import AppConfig from '../Configuration'
import ApiClient from "../bff-client/src/ApiClient";
import CustomersApi from "../bff-client/src/api/CustomersApi";
import EmailApi from "../bff-client/src/api/EmailApi";

import {
  Text,
  Title,
  Description,
  Space,
  Button,
  TextInputExtended,
  KeyboardAvoidingView,
  ReturnFooter,
  Anchor
} from '@sart/components'

import NeedHelpFooter from '../NeedHelpFooter'
import * as theme from './signTheme'
import { GuruFullBodyCallMe, CompanyIcon } from '@sart/icons'
import { Dimensions } from 'react-native'

export default function SignUpRegisterNumber(props) {
  const content = useContent()

  const bffClient = new ApiClient(AppConfig.bffBasePath)
  bffClient.defaultHeaders = {
    ...bffClient.defaultHeaders,
    Origin: AppConfig.shopOriginUrl
  }
  const customersApi = new CustomersApi(bffClient)
  const emailApi = new EmailApi(bffClient);

  const { navigation } = props

  let emailRef

  const formik = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().trim().email().required(content.forms.required)
    }),
    onSubmit: handlePhoneRegistration,
  })

  async function handlePhoneRegistration(values, form) {
    Keyboard.dismiss()
    form.setSubmitting(true)
    try {
      console.log('valus are: ' + JSON.stringify(values, null, 2))
      values.email = values.email.trim().toLowerCase()

      const subscriptionInfoResp = await customersApi.customersSubscriptionsPendingGet(values.email)
      console.log('subscriptionInfoResp is: ' + JSON.stringify(subscriptionInfoResp, null, 2))

      if (!subscriptionInfoResp.email) {
        console.log('Email does not exist')
        form.setFieldError('email', content.register_number.emailDoesNotExist)
        form.setSubmitting(false)
        return
      } else if (subscriptionInfoResp.registered) {
        //Already Registered
        form.setFieldError('email', content.errors.alreadyRegistered)
        form.setSubmitting(false)
        return
      }

      // Call the API to send OTP
      emailApi.emailVerifyPost({ email: values.email, register: true });

      const params = { email: values.email, ncaFlow: false }
      navigation.navigate('VerifyNumber', values)

    } catch (error) {
      //undo the number change from before
      // values.number = values.number.replace(AppConfig.iccidPrefix, '')
      console.log('Error during registration:', error)
      const message = prettyErrorMessage(error, 'registration', content)
      form.setFieldError('email', message)
      form.setSubmitting(false)
    }
  }

  return (
    <View style={styles.container}>
      {/* <ScrollView style={styles.scrollViewContainer} keyboardShouldPersistTaps={'always'}> */}
      <KeyboardAvoidingView style={styles.content}>
        <Space height={styles.spaceHeightOne.height} />
        <View style={styles.logo}>
          <Image
            source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
            height={styles.logoStyle.height} width={200} alignSelf={"center"}
          />
          {/* <CompanyIcon color={colors.white} height={styles.logoStyle.height} width={200} /> */}
        </View>
        <Title {...theme.title}>{content.register_number.title}</Title>

        <Space height={styles.spaceHeightTwo.height} />

        <TextInputExtended
          label={content.register_number.emailLabel}
          value={formik.values.email}
          placeholder={content.register_number.emailPlaceholder}
          keyboardType="email-address"
          autoCapitalize="none"
          {...Platform.select({
            web: { autoComplete: 'email' },
            ios: { textContentType: 'emailAddress' },
            android: { autoCompleteType: 'email' }
          })}
          onChangeText={formik.handleChange('email')}
          onBlur={formik.handleBlur('email')}
          error={formik.touched.email && formik.errors.email}
          footer={content.register_number.emailSubtext}
          {...theme.textInput}
          // ref={ref => {
          //   emailRef = ref;
          // }}
          returnKeyType="go"
          onSubmitEditing={formik.handleSubmit}
          {...testID('SignUpRegisterEmail')}
        />

        <Space height={12} />

        <Button
          title={
            formik.isSubmitting
              ? content.register_number.inProgress
              : content.register_number.action
          }
          disabled={!formik.dirty || !formik.isValid || formik.isSubmitting}
          onPress={formik.handleSubmit}
          {...theme.button}
          titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
          disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white + 45 }}
          {...testID('SignUpRegisterSubmit')}
        />
        <Space height={12} />

        {/* <Text style={styles.footerStyle}>{content.register_number.note}</Text> */}

        {/* <Space height={24} /> */}
        <ReturnFooter
          cancelStyle={styles.cancelStyle}
          title={content.common.cancel}
          onPress={() => navigation.navigate('RegistrationHome')}
        />
      </KeyboardAvoidingView>
      {/* </ScrollView> */}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minHeight: '100%',
    backgroundColor: backgroundColors.darkCharcoal,
    // height: Dimensions.get('window').height
    width: '100%',
    alignItems: 'center'
  },
  scrollViewContainer: {
    flex: 1,
    backgroundColor: backgroundColors.darkCharcoal,
    maxWidth: 600
  },
  content: {
    flex: 1,
    ...adaptive.wrapperPadding,
    justifyContent: 'center',
    ...adaptive.logoPadding,
    // height: '100%',
    // paddingTop: 24,
    // ...adaptive.contentHeight,
    // height: Dimensions.get('window').height
  },
  cancel: {
    justifyContent: 'center',
    alignItems: 'center',
    // padding: 24
  },
  logoStyle: {
    ...adaptive.guruSize
  },
  cancelStyle: {
    color: colors.white
  },
  footerStyle: {
    color: colors.white
  },
  spaceHeightOne: {
    ...adaptive.spaceHeightRegisterScreenOne
  },
  spaceHeightTwo: {
    ...adaptive.spaceHeightRegisterScreenTwo
  },
  spaceHeightThree: {
    ...adaptive.spaceHeightRegisterScreenThree
  },
  description: {
    textAlign: 'center',
    ...typography.demi,
    color: colors.srGreen
  },
  link: {
    color: colors.clear,
    fontSize: 14
  },
  logo: {
    alignSelf: "center"
  },
  text: {
    color: colors.srGreen,
    fontSize: 14
  },
})
